import React, { useEffect, useState } from 'react';
import { makeRequest } from '../../utils/httpRequest';
import Config from '../../core/config';
import ListPageLayout from '../common/ListPageLayout';

const apiUrl = Config.apiUrl;

const formatLocal = (iso) => new Date(iso + 'Z').toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
});

const Stars = ({ rating }) => (
    <span style={{ color: '#FFB353', fontSize: '15px', letterSpacing: '1px' }}>
        {'★'.repeat(rating)}
        <span style={{ color: '#d4ccc6' }}>{'★'.repeat(5 - rating)}</span>
    </span>
);

const SystemFeedbackList = () => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        makeRequest(`${apiUrl}/api/system-feedback`, 'GET')
            .then(setData)
            .catch(() => setError('Erro ao carregar avaliações.'));
    }, []);

    if (error) return <p style={{ color: 'var(--semantic-error-text)', padding: '16px' }}>{error}</p>;
    if (!data) return <p style={{ padding: '16px' }}>Carregando...</p>;

    const { items, total, average, countByStar } = data;

    return (
        <ListPageLayout
            tableWidth={720}
            header={<div className="header-label">Avaliações do Sistema</div>}
        >
            <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginBottom: '20px' }}>
                <SummaryCard label="Total de avaliações" value={total} />
                <SummaryCard label="Média geral" value={
                    <span>{average} <Stars rating={Math.round(average)} /></span>
                } />
                <div style={cardStyle}>
                    <div style={cardLabelStyle}>Distribuição</div>
                    {[5, 4, 3, 2, 1].map(star => (
                        <div key={star} style={{ display: 'flex', alignItems: 'center', gap: '6px', marginTop: '3px' }}>
                            <Stars rating={star} />
                            <div style={{ flex: 1, height: '8px', background: '#efefef', borderRadius: '4px', overflow: 'hidden', minWidth: '80px' }}>
                                <div style={{
                                    width: total > 0 ? `${((countByStar[star] || 0) / total) * 100}%` : '0%',
                                    height: '100%',
                                    background: 'var(--palette-amber)',
                                    borderRadius: '4px',
                                }} />
                            </div>
                            <span style={{ fontSize: '12px', color: 'var(--color-text-secondary)', minWidth: '20px' }}>
                                {countByStar[star] || 0}
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            <table>
                <thead>
                    <tr>
                        <th>Usuário</th>
                        <th>Nota</th>
                        <th>Comentário</th>
                        <th>Data</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map(item => (
                        <tr key={item.id}>
                            <td style={{ whiteSpace: 'nowrap' }}>
                                <div style={{ fontWeight: 500, fontSize: '14px' }}>{item.userName}</div>
                                <div style={{ fontSize: '12px', color: 'var(--color-text-secondary)', marginTop: '2px' }}>{item.companyName}</div>
                            </td>
                            <td style={{ whiteSpace: 'nowrap' }}><Stars rating={item.rating} /></td>
                            <td style={{ maxWidth: '340px', wordBreak: 'break-word' }}>
                                {item.comment || <span style={{ color: 'var(--color-text-secondary)', fontStyle: 'italic' }}>—</span>}
                            </td>
                            <td style={{ whiteSpace: 'nowrap', color: 'var(--color-text-secondary)', fontSize: '13px' }}>{formatLocal(item.createdAt)}</td>
                        </tr>
                    ))}
                </tbody>
                {items.length === 0 && <tfoot><tr><td colSpan={4}>Nenhuma avaliação registrada.</td></tr></tfoot>}
            </table>
        </ListPageLayout>
    );
};

const cardStyle = {
    background: 'var(--color-bg-panel)',
    border: '1px solid var(--color-border)',
    borderRadius: '10px',
    padding: '14px 18px',
    minWidth: '140px',
};

const cardLabelStyle = {
    fontSize: '12px',
    color: 'var(--color-text-secondary)',
    marginBottom: '6px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
};

const SummaryCard = ({ label, value }) => (
    <div style={cardStyle}>
        <div style={cardLabelStyle}>{label}</div>
        <div style={{ fontSize: '22px', fontWeight: 600, color: 'var(--color-text-heading)' }}>{value}</div>
    </div>
);

export default SystemFeedbackList;
